import i18next, { type i18n as I18nInstance } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import { FALLBACK_LOCALE, LOCALES, resources, type Locale } from '@h3eromap/i18n';

export const i18n: I18nInstance = i18next.createInstance();

// Keep <html lang> in step with the active language from the very first
// detection on (WCAG 3.1.1 — screen readers pick the voice from it).
// Registered before init() because init fires the first languageChanged.
i18n.on('languageChanged', (lng: string) => {
  document.documentElement.lang = i18n.resolvedLanguage ?? lng;
});

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: FALLBACK_LOCALE,
    supportedLngs: LOCALES,
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false, // React already escapes
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'h3eromap.lang',
      caches: ['localStorage'],
    },
  });

/**
 * Switch the active language and persist it.
 *
 * `react-i18next` re-renders subscribed components synchronously, so the swap
 * is instant — no page reload required (LOC-089 acceptance criterion).
 */
export async function setLocale(locale: Locale): Promise<void> {
  await i18n.changeLanguage(locale);
  document.documentElement.lang = locale;
}

export type { Locale };
